module.exports = __webpack_public_path__ + "static/media/jakarta-seletan.d32de9ff.svg";